/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from '@servicetitan/application-data/common-interfaces';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IDashboardApi {
    getClassicDashboard(request: ClassicDashboardRequest, cancelToken?: CancelToken): AxiosPromise<ClassicDashboardModel>;
    getAnalyticsDashboard(request: AnalyticsDashboardRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<AnalyticsDashboardModel>;
    getTopCategories(request: TopCategoriesRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<ListResultOfAnalyticsCategoryRow>;
    getMarketingHistoricalDataByBU(from: Date, to: Date, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<MarketingHistoricalDataByBU[]>;
    getMarketingHistoricalDataByCategory(from: Date, to: Date, chartType: MarketingGoalChartType, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<MarketingHistoricalDataByCategory[]>;
    getTopCampaigns(request: TopCampaignsRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<ListResultOfAnalyticsCampaignRow>;
    getCategoryCampaigns(request: CategoryCampaignsRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<CategoryDetailsCampaignRow[]>;
    getCategoryDetails(request: CategoryRequest, cancelToken?: CancelToken): AxiosPromise<CategoryDetailsModel>;
    getMarketingMetricsTotals(request: MarketingMetricsRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<AnalyticsCampaignMetrics>;
    getCampaignMetricsGraph(request: MetricsGraphRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<GraphModel>;
    getEmailDetailsMetrics(request: EmailDetailsMetricsRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<EmailMetrics[]>;
    getAnalyticsStats(cancelToken?: CancelToken): AxiosPromise<MarketingStats>;
}

export const BASE_URL_TOKEN_DashboardApi = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class DashboardApi implements IDashboardApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject(BASE_URL_TOKEN_DashboardApi) @optional() private readonly baseUrl = "") {
    }

    getClassicDashboard(request: ClassicDashboardRequest, cancelToken?: CancelToken): AxiosPromise<ClassicDashboardModel> {
        let url_ = "/app/api/marketing/dashboard/classic-dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = makeContent(request, [
            "$.from",
            "$.to",
        ]);

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ClassicDashboardModel>(options_));
    }

    getAnalyticsDashboard(request: AnalyticsDashboardRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<AnalyticsDashboardModel> {
        let url_ = "/app/api/marketing/dashboard/analytics-dashboard?";
        if (attributionModel !== undefined && attributionModel !== null)
            url_ += "attributionModel=" + encodeURIComponent("" + attributionModel) + "&";
        if (includeManualTouchPoints !== undefined && includeManualTouchPoints !== null)
            url_ += "includeManualTouchPoints=" + encodeURIComponent("" + includeManualTouchPoints) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = makeContent(request, [
            "$.from",
            "$.prevFrom",
            "$.prevTo",
            "$.to",
        ]);

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<AnalyticsDashboardModel>(options_));
    }

    getTopCategories(request: TopCategoriesRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<ListResultOfAnalyticsCategoryRow> {
        let url_ = "/app/api/marketing/dashboard/top-categories?";
        if (attributionModel !== undefined && attributionModel !== null)
            url_ += "attributionModel=" + encodeURIComponent("" + attributionModel) + "&";
        if (includeManualTouchPoints !== undefined && includeManualTouchPoints !== null)
            url_ += "includeManualTouchPoints=" + encodeURIComponent("" + includeManualTouchPoints) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = makeContent(request, [
            "$.from",
            "$.to",
        ]);

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ListResultOfAnalyticsCategoryRow>(options_));
    }

    getMarketingHistoricalDataByBU(from: Date, to: Date, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<MarketingHistoricalDataByBU[]> {
        let url_ = "/app/api/marketing/dashboard/historical-data-byBU?";
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + moment(from).format("YYYY-MM-DDTHH:mm:ss") : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + moment(to).format("YYYY-MM-DDTHH:mm:ss") : "") + "&";
        if (attributionModel !== undefined && attributionModel !== null)
            url_ += "attributionModel=" + encodeURIComponent("" + attributionModel) + "&";
        if (includeManualTouchPoints !== undefined && includeManualTouchPoints !== null)
            url_ += "includeManualTouchPoints=" + encodeURIComponent("" + includeManualTouchPoints) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<MarketingHistoricalDataByBU[]>(options_));
    }

    getMarketingHistoricalDataByCategory(from: Date, to: Date, chartType: MarketingGoalChartType, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<MarketingHistoricalDataByCategory[]> {
        let url_ = "/app/api/marketing/dashboard/historical-data-category?";
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + moment(from).format("YYYY-MM-DDTHH:mm:ss") : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + moment(to).format("YYYY-MM-DDTHH:mm:ss") : "") + "&";
        if (chartType === undefined || chartType === null)
            throw new Error("The parameter 'chartType' must be defined and cannot be null.");
        else
            url_ += "chartType=" + encodeURIComponent("" + chartType) + "&";
        if (attributionModel !== undefined && attributionModel !== null)
            url_ += "attributionModel=" + encodeURIComponent("" + attributionModel) + "&";
        if (includeManualTouchPoints !== undefined && includeManualTouchPoints !== null)
            url_ += "includeManualTouchPoints=" + encodeURIComponent("" + includeManualTouchPoints) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<MarketingHistoricalDataByCategory[]>(options_));
    }

    getTopCampaigns(request: TopCampaignsRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<ListResultOfAnalyticsCampaignRow> {
        let url_ = "/app/api/marketing/dashboard/top-campaigns?";
        if (attributionModel !== undefined && attributionModel !== null)
            url_ += "attributionModel=" + encodeURIComponent("" + attributionModel) + "&";
        if (includeManualTouchPoints !== undefined && includeManualTouchPoints !== null)
            url_ += "includeManualTouchPoints=" + encodeURIComponent("" + includeManualTouchPoints) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = makeContent(request, [
            "$.from",
            "$.to",
        ]);

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ListResultOfAnalyticsCampaignRow>(options_));
    }

    getCategoryCampaigns(request: CategoryCampaignsRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<CategoryDetailsCampaignRow[]> {
        let url_ = "/app/api/marketing/dashboard/category-campaigns?";
        if (attributionModel !== undefined && attributionModel !== null)
            url_ += "attributionModel=" + encodeURIComponent("" + attributionModel) + "&";
        if (includeManualTouchPoints !== undefined && includeManualTouchPoints !== null)
            url_ += "includeManualTouchPoints=" + encodeURIComponent("" + includeManualTouchPoints) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = makeContent(request, [
            "$.from",
            "$.to",
        ]);

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<CategoryDetailsCampaignRow[]>(options_));
    }

    getCategoryDetails(request: CategoryRequest, cancelToken?: CancelToken): AxiosPromise<CategoryDetailsModel> {
        let url_ = "/app/api/marketing/dashboard/category-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<CategoryDetailsModel>(options_));
    }

    getMarketingMetricsTotals(request: MarketingMetricsRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<AnalyticsCampaignMetrics> {
        let url_ = "/app/api/marketing/dashboard/marketing-metrics-totals?";
        if (attributionModel !== undefined && attributionModel !== null)
            url_ += "attributionModel=" + encodeURIComponent("" + attributionModel) + "&";
        if (includeManualTouchPoints !== undefined && includeManualTouchPoints !== null)
            url_ += "includeManualTouchPoints=" + encodeURIComponent("" + includeManualTouchPoints) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = makeContent(request, [
            "$.from",
            "$.prevFrom",
            "$.prevTo",
            "$.to",
        ]);

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<AnalyticsCampaignMetrics>(options_));
    }

    getCampaignMetricsGraph(request: MetricsGraphRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<GraphModel> {
        let url_ = "/app/api/marketing/dashboard/campaign-metrics-graph?";
        if (attributionModel !== undefined && attributionModel !== null)
            url_ += "attributionModel=" + encodeURIComponent("" + attributionModel) + "&";
        if (includeManualTouchPoints !== undefined && includeManualTouchPoints !== null)
            url_ += "includeManualTouchPoints=" + encodeURIComponent("" + includeManualTouchPoints) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = makeContent(request, [
            "$.from",
            "$.prevFrom",
            "$.prevTo",
            "$.to",
        ]);

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<GraphModel>(options_));
    }

    getEmailDetailsMetrics(request: EmailDetailsMetricsRequest, attributionModel: AttributionModel | null | undefined, includeManualTouchPoints: boolean | null | undefined, cancelToken?: CancelToken): AxiosPromise<EmailMetrics[]> {
        let url_ = "/app/api/marketing/dashboard/email-details-metrics?";
        if (attributionModel !== undefined && attributionModel !== null)
            url_ += "attributionModel=" + encodeURIComponent("" + attributionModel) + "&";
        if (includeManualTouchPoints !== undefined && includeManualTouchPoints !== null)
            url_ += "includeManualTouchPoints=" + encodeURIComponent("" + includeManualTouchPoints) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = makeContent(request, [
            "$.from",
            "$.to",
        ]);

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<EmailMetrics[]>(options_));
    }

    getAnalyticsStats(cancelToken?: CancelToken): AxiosPromise<MarketingStats> {
        let url_ = "/app/api/marketing/dashboard/stats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<MarketingStats>(options_));
    }
}

export interface ClassicDashboardModel {
    emailMetrics: EmailDashboardModel;
    revenueMetrics: RevenueDashboardModel;
    campaignMetrics: CampaignDashboardRow[];
    hasAnyCampaigns: boolean;
}

export interface EmailDashboardModel {
    sent: number;
    delivered: number;
    deliveryRate?: number | undefined;
    opened: number;
    openRate?: number | undefined;
    clicked: number;
    clickRate?: number | undefined;
    called: number;
    callRate?: number | undefined;
    unsubscribed: number;
    unsubscribeRate?: number | undefined;
}

export interface RevenueDashboardModel {
    totalRevenue: number;
    bookings: number;
    bookingRate?: number | undefined;
    soldJobs: number;
    soldJobsRate?: number | undefined;
}

export interface CampaignDashboardRow {
    id: number;
    campaignName: string;
    launch: Date;
    isLive: boolean;
    status: MarketingCampaignStatus;
    channel: MarketingChannel;
    revenue: number;
    attributedRevenue: number;
    sent: number;
    openRate?: number | undefined;
    clickRate?: number | undefined;
    calls: number;
    booked: number;
    converted: number;
    revenuePerJob?: number | undefined;
    campaignId: number;
    delivered: number;
    opened: number;
    clicked: number;
    unsubscribed: number;
    deliveryLogic: DeliveryLogic;
}

export enum MarketingCampaignStatus {
    Draft = 1000,
    Scheduled = 2000,
    Live = 3000,
    Finished = 4000,
    Stopped = 5000,
    Processing = 6000,
}

export enum MarketingChannel {
    DirectMail = 0,
    Email = 1,
    Legacy = 2,
    PowerDialer = 3,
    Sms = 4,
    Digital = 5,
    MultiChannel = 6,
}

export enum DeliveryLogic {
    OneTime = 0,
    Ongoing = 1,
}

export interface ClassicDashboardRequest {
    from: Date;
    to: Date;
    buIds: number[];
}

export interface AnalyticsDashboardModel {
    totals: TotalsModel;
    graph: GraphModel;
}

export interface TotalsModel {
    calls: MetricModel;
    booked: MetricModel;
    sold: MetricModel;
    revenue: MetricModel;
}

export interface MetricModel {
    total: number;
    diff: number;
    diffRatio?: number | undefined;
}

export interface GraphModel {
    resolution: GraphResolution;
    metrics: GraphMetricModel[];
    partialWeeks?: PartialWeeks | undefined;
}

export enum GraphResolution {
    Day = 0,
    Week = 1,
}

export interface GraphMetricModel {
    id: MetricId;
    data: number[];
}

export enum MetricId {
    Unknown = 0,
    Calls = 1,
    Leads = 2,
    Booked = 3,
    ManualCalls = 4,
    NewCustomers = 5,
    Revenue = 6,
    RoiRate = 7,
    EmailRoiRate = 8,
    AttributedRevenue = 9,
    SoldJobs = 10,
    EmailSent = 11,
    DirectMailFailed = 12,
    Delivered = 13,
    Opened = 14,
    Clicked = 15,
    Unsubscribed = 16,
    AverageRevenuePerOpen = 17,
    AttributedCalls = 18,
    AttributedJobs = 19,
    DirectMailShipped = 20,
    AverageRevenuePerJob = 21,
    CompletedJobs = 22,
    EmailCostPerLead = 23,
    EmailMonthlyCost = 24,
    TotalDailyCost = 25,
    CostPerLead = 26,
    AverageRevenuePerSmsReply = 30,
    SmsReply = 31,
    SmsSent = 32,
    SmsReplyRate = 33,
    SmsCostPerLead = 34,
    SmsMonthlyCost = 35,
    DispatchedJobs = 36,
    DirectMailOrdered = 37,
    DirectMailPlaced = 38,
    DirectMailPrinting = 39,
    OnlineBooking = 40,
    BookedJobsByCall = 41,
    SmsClicked = 42,
    SmsClickedRate = 43,
    MarketingSmsCost = 44,
    SmsClickedAttributedRevenue = 45,
    SmsUnsubscribed = 46,
}

export interface PartialWeeks {
    leftDays: number;
    wholeDays: number;
    rightDays: number;
}

export interface AnalyticsDashboardRequest {
    from: Date;
    to: Date;
    prevFrom: Date;
    prevTo: Date;
    buIds: number[];
    proCampaignsOnly: boolean;
}

export enum AttributionModel {
    AssignedCampaign = 0,
    FirstTouch = 1,
    LastTouch = 2,
}

export interface ListResultOfAnalyticsCategoryRow {
    totalCount: number;
    items: AnalyticsCategoryRow[];
}

export interface AnalyticsCategoryRow {
    id: string;
    name?: string | undefined;
    channel: MarketingChannel;
    isPro: boolean;
    calls: number;
    booked: number;
    sold: number;
    revenue: number;
    liveCampaignsCount: number;
    idleCampaignsCount: number;
}

export interface TopCategoriesRequest {
    from: Date;
    to: Date;
    buIds: number[];
    topListRequest: TopListRequest;
}

export interface TopListRequest {
    sorting?: SortCriteria[] | undefined;
    skip: number;
    take: number;
}

export interface SortCriteria {
    name: string;
    desc: boolean;
}

export interface MarketingHistoricalDataByBU {
    businessUnitName: string;
    marketingHistoricalDataByMonths: MarketingHistoricalDataByMonth[];
}

export interface MarketingHistoricalDataByMonth {
    from: Date;
    to: Date;
    name: string;
    revenue: number;
    calls: number;
    leads: number;
    bookedJobs: number;
    completedJobs: number;
}

export interface MarketingHistoricalDataByCategory {
    categoryName: string;
    categoryId: string;
    marketingHistoricalDataByMonths: MarketingHistoricalDataByMonth[];
}

export enum MarketingGoalChartType {
    None = 0,
    Day = 1,
    Week = 2,
    Month = 3,
}

export interface ListResultOfAnalyticsCampaignRow {
    totalCount: number;
    items: AnalyticsCampaignRow[];
}

export interface AnalyticsCampaignRow {
    campaignId: number;
    externalCampaignId?: number | undefined;
    name: string;
    channel: MarketingChannel;
    category?: string | undefined;
    calls: number;
    booked: number;
    sold: number;
    revenue: number;
    phoneNumber?: MarketingPhoneNumberModel | undefined;
    createdOn?: Date | undefined;
    modifiedOn: Date;
    modifiedBy?: string | undefined;
    proCampaign?: ProCampaignModel | undefined;
}

export interface MarketingPhoneNumberModel {
    value: string;
    type: MarketingNumberType;
}

export enum MarketingNumberType {
    Tracking = 0,
    Manual = 1,
}

export interface ProCampaignModel {
    deliveryLogic: DeliveryLogic;
    campaignType: CampaignType;
    status: MarketingCampaignStatus;
    launchDate?: Date | undefined;
}

export enum CampaignType {
    Default = 0,
    UnsoldEstimates = 1,
    ExpiringMemberships = 2,
    IdleAccount = 3,
    AgingEquipment = 4,
    Other = 5,
    RecurringService = 6,
    Newsletter = 7,
    ThankYou = 8,
    CustomerWelcome = 9,
    MissedCalls = 10,
}

export interface TopCampaignsRequest extends TopCategoriesRequest {
    audienceId?: number | undefined;
    externalAudienceId?: string | undefined;
}

export interface CategoryDetailsCampaignRow {
    channel: MarketingChannel;
    id: number;
    deliveryLogic?: DeliveryLogic | undefined;
    name: string;
    launchDate?: Date | undefined;
    status?: MarketingCampaignStatus | undefined;
    metrics: { [key in keyof typeof MetricId]?: number; };
}

export interface CategoryRequest {
    channel: MarketingChannel;
    categoryId?: number | undefined;
}

export interface CategoryCampaignsRequest extends CategoryRequest {
    from: Date;
    to: Date;
    buIds: number[];
}

export interface CategoryDetailsModel {
    channel: MarketingChannel;
    name?: string | undefined;
}

export interface AnalyticsCampaignMetrics {
    /** (MetricId, null) kv pair means that the metric can't be calculated because we don't have data (e.g. TotalDailyCost when the cost is not set for the period)
if there's no pair for a given key, it means that metric doesn't make sense for that channel (e.g. SmsSent when we're requesting metrics for a tracking campaign) */
    totals: { [key in keyof typeof MetricId]?: MetricModel; };
}

export interface MarketingMetricsRequest {
    metricIds: MetricId[];
    campaignId?: number | undefined;
    categoryId?: number | undefined;
    channel: MarketingChannel;
    from: Date;
    to: Date;
    prevFrom: Date;
    prevTo: Date;
    buIds: number[];
}

export interface MetricsGraphRequest {
    campaignId: number;
    channel: MarketingChannel;
    from: Date;
    to: Date;
    prevFrom: Date;
    prevTo: Date;
    buIds: number[];
}

export interface EmailMetrics {
    sequenceNumber: number;
    metrics: { [key in keyof typeof MetricId]?: EmailMetric; };
}

export interface EmailMetric {
    total: number;
    percentage: number;
}

export interface EmailDetailsMetricsRequest {
    proCampaignId: number;
    from: Date;
    to: Date;
}

export interface MarketingStats {
    company: string;
    businessPhone: string;
    openEstimates: number;
    expiringMemberships: number;
    expiredMemberships: number;
    oldEquipment: number;
    idleCustomers: number;
}
